export class MeasurementSystems {
	static imperial: string = "Imperial";
	static metric: string = "Metric";
}